import { AIProvider } from './provider/ai-provider';
import { AIRequestService } from './runtime/request/service';

export * from './groq-stream';
import { getProviderApiKey, streamGroqToAffineUI } from './groq-stream';

// Override AFFiNE's built-in AI actions so the native UI works seamlessly in Vietnamese & English via Cao Oi!
export function hijackAffineAIWithCaoOi() {
  const actionsToOverride = [
    'chat',
    'summary',
    'explain',
    'translate',
    'improveWriting',
    'makeLonger',
    'makeShorter',
    'continueWriting',
    'fixSpelling',
    'fixGrammar',
  ] as const;

  // 1. Hook into AIProvider
  actionsToOverride.forEach((actionName) => {
    try {
      (AIProvider as any).provide(actionName, (options: any) => {
        const userPrompt =
          options?.input ||
          options?.prompt ||
          `Thực hiện "${actionName}" một cách chuyên nghiệp, súc tích và phù hợp ngữ cảnh (ưu tiên tiếng Việt phong thái điều hành CEO cho Chị Mai Quyên):`;
        const selection = options?.content || (typeof window !== 'undefined' ? window.getSelection()?.toString() : '') || '';

        return streamGroqToAffineUI(userPrompt, selection);
      });
    } catch (e) {
      console.warn(`[CaoOi] Could not provide action ${actionName} on AIProvider:`, e);
    }
  });

  // 2. Patch AIRequestService.prototype.executeAction so that ANY execution in AFFiNE runtime routes through Groq/Gemini
  const originalExecuteAction = AIRequestService.prototype.executeAction;
  AIRequestService.prototype.executeAction = async function (id: any, options: any) {
    // If API key is available, intercept the action with Cao Oi
    const activeKey = getProviderApiKey();
    if (activeKey) {
      this.actionHistory.push({ action: id, options });
      if (this.actionHistory.length > 10) {
        this.actionHistory.shift();
      }
      this.actionEvents$.next({ action: id, options, event: 'started' });

      let textContent = options?.input || options?.prompt || '';
      const selection = options?.content || (typeof window !== 'undefined' ? window.getSelection()?.toString() : '') || '';
      if (!textContent && selection) {
        textContent = selection;
      }

      let userPrompt = textContent;
      if (id === 'explain') {
        userPrompt = `Giải thích rõ ràng, chi tiết và có ví dụ ứng dụng thực tiễn trong điều hành & quản trị doanh nghiệp cho nội dung sau:\n\n${textContent}`;
      } else if (id === 'summary') {
        userPrompt = `Hãy tóm tắt ngắn gọn, sắc bén và làm nổi bật các ý chính theo phong thái điều hành CEO cho nội dung sau:\n\n${textContent}`;
      } else if (id === 'translate') {
        userPrompt = `Dịch nội dung sau sang tiếng Việt chuẩn mực, tự nhiên:\n\n${textContent}`;
      } else if (id === 'improveWriting') {
        userPrompt = `Trau chuốt và nâng tầm văn phong của đoạn sau, đảm bảo gãy gọn, sắc bén và súc tích:\n\n${textContent}`;
      } else if (id === 'makeLonger') {
        userPrompt = `Mở rộng và làm sâu sắc thêm các luận điểm trong đoạn sau:\n\n${textContent}`;
      } else if (id === 'makeShorter') {
        userPrompt = `Cô đọng và chắt lọc các điểm mấu chốt nhất từ đoạn sau thành các gạch đầu dòng súc tích:\n\n${textContent}`;
      } else if (id === 'continueWriting') {
        userPrompt = `Viết tiếp một cách mượt mà và logic mạch ý của văn bản sau:\n\n${textContent}`;
      } else if (id === 'fixSpelling' || id === 'fixGrammar') {
        userPrompt = `Sửa tất cả các lỗi chính tả và ngữ pháp trong văn bản sau:\n\n${textContent}`;
      } else if (!userPrompt) {
        userPrompt = `Thực hiện "${id}" một cách chuyên nghiệp, súc tích và phù hợp ngữ cảnh:`;
      }

      const stream = streamGroqToAffineUI(userPrompt, selection);
      return (this as any).wrapTextStream(stream, id, options);
    }

    return originalExecuteAction.call(this, id, options);
  };

  console.info('✨ [Cao Oi] AFFiNE AI bridge activated successfully with Groq + Persistent Memory!');
}
